<template>
  <div id="chart-line" v-loading="chartLoading">
    <el-row>
      <el-col :span="24">
        <div id="plotly" ref="plotly"  style="width:600px;margin:auto" />
      </el-col>
      <el-col :span="24">
        <ChartTimeMini :rawData="rawData" :samplingRate="samplingRate" v-model="visibleRange"></ChartTimeMini>

        <el-row class="toolbox">
          <el-col>
            <el-form ref="form" inline label-position="top" label-width="100px" size="small" >
              <el-form-item :label="$t('measurement.window')">
                <el-select v-model="window">
                  <el-option v-for="window in windows" :key="window" :label="window" :value="window" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('measurement.referenceFrequency')">
                <el-input type="number" @blur="init" @keyup.enter.native="init" v-model="localReferenceFrequency">
                </el-input>
                <span v-if="localReferenceFrequency==0" style="color:red">{{$t("common.rotationspeed")}}</span>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Plotly from "./Plotly";
import cachios from "cachios";
import ChartTimeMini from "./Chart_TimeMini";
export default {
  name: "polaranalyze-chart",
  events: [],
  props: {
    rawData: {
      type: Array,
    },
    samplingRate: {
      type: Number,
      default: 0,
    },
    referenceFrequency: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Plotly,
    ChartTimeMini,
  },
  data() {
    return {
      chartLoading: true,
      series: [
        {
          x: [],
          y: [],
        },
      ],
      localReferenceFrequency: 0,
      visibleRange: [],
      window: "rectangular",
      windows: ["rectangular", "hanning", "flattop", "hamming", "blackman"],
      layout: {
        title: 'Mic Patterns',
        font: {
          family: 'Arial, sans-serif;',
          size: 12,
          color: '#000'
        },
        showlegend: true,
        orientation: -90,

        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 0,
        },
        displaylogo: false,
      },
      modebar: {
        orientation: "v",
      },
    };
  },
  mounted() {
    this.visibleRange = [0, this.rawData.length - 1];
    window.addEventListener("mousedown", this.mouseDown);
    this.localReferenceFrequency = 0 + this.referenceFrequency;
  },
  methods: {
    mouseDown(e) {
      this.mouseBeforeX = e.offsetX;
    },
    init() {
      this.chartLoading = true;
      cachios
        .post(`${process.env.VUE_APP_VIBRATION_APIURL}/signal/polar-analyze`, {
          window: this.window,
          dcOffset: true,
          referenceFrequency: parseFloat(this.localReferenceFrequency),
          signal: this.rawData.slice(
            this.visibleRange[0],
            this.visibleRange[1]
          ),
          samplingRate: this.samplingRate,
        })
        .then(async (response) => {
          var polar = {

            r: response.data.r,
            theta: response.data.phase.map(y => (y * 180 / Math.PI) - 90),
            thetaunit: 'degrees',
            mode: 'lines',
            name: 'polar',
            marker: {
              color: 'rgb(191 191 191)',
            },
            type: 'scatterpolar',
          };
          var mean = {

            r: response.data.r_mean,
            theta: response.data.phase_mean.map(y => (y * 180 / Math.PI) - 90),
            thetaunit: 'degrees',
            mode: 'lines',
            name: 'mean',
            marker: {
              color: '#00519D',

            },
            type: 'scatterpolar',
          };
          var data = [polar, mean];

          var layout = {
            height: 600,
            width: 600,
            margin: "auto",

            displaylogo: false,
            polar: {

              radialaxis: {
                tickfont: {
                  size: 12
                },
                // range: [-2, 1.5],
                //tickangle: 45
              },

              angularaxis: {
                tickfont: {
                  size: 12
                },
                dtick: 30,
                rotation: 90,
                direction: "clockwise"
              }
            },
            title: '',
          };
          let pl = await Plotly.newPlot(this.$refs.plotly, data, layout, {
            displayModeBar: true,
            displaylogo: false,
            doubleClick: "reset",
            responsive: true,
          });

          console.log(pl);
        })
        .finally(() => {
          this.chartLoading = false;
        });
    },
  },
  watch: {
    visibleRange: function (range) {
      this.init();
    },
    rawData: function () {
      this.init();
    },
    window: function () {
      this.init();
    },
  },
};
</script>
<style>
.apexcharts-toolbar {
  top: 15px !important;
  right: 5px !important;
}
</style>
<style scoped>
.measurementDelete {
  float: right;
}

*:focus {
  outline: -webkit-focus-ring-color auto 0px;
}

.apexcharts-tooltip.apexcharts-theme-light {
  line-height: 9px;
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0px;
}
</style>
